export default __webpack_public_path__ + "static/media/bg.d71af21e.jpg";